import IconStadiumTour from '../../static/icons/experiences/icon_stadium_tour.svg';
import IconPlayersPhoto from '../../static/icons/experiences/icon_players_photo.svg';
import IconPlayerStats from '../../static/icons/experiences/icon_players_stats.svg';
import StadiumTourVideo from '../../static/videos/experiences/portal_1.mp4';
import PlayersPhotoVideo from '../../static/videos/experiences/player_photo_1.mp4';
import PlayerStatsVideo from '../../static/videos/experiences/player_stats_1.mp4';

const Experiences = [
    {
        topic: 'Stadium Tour',
        title: 'Stadium Tour',
        // text: 'Give your fans access to the stadium. Let them feel special and open the doors to the pitch, the dressing room, the access tunnel, the museum, trophy room and much more.',
        text: 'Let the fans take a peak of the backstage. Thanks to our Stadium mode, club supporters will be able to step on the pitch, enter the dressing room and access exclusive areas.',
        icon: IconStadiumTour,
        video: StadiumTourVideo,
    },
    {
        topic: 'Player Photo',
        title: 'Player Photo',
        // text: 'What can be more special than taking a photo with your favorite player? The fans go crazy about this, here they can take a photo or even record themselves next to the players.',
        text: 'Interacting with personalities, like football players, is an easily overcome barrier thanks to our Player experience. Unique moments will take place with this mode. Fans will be able to take pictures and make videos with ultra realistic 3D versions of their heroes.  ',
        icon: IconPlayersPhoto,
        video: PlayersPhotoVideo,
    },
    {
        topic: 'Player Stats',
        title: 'Player Stats',
        // text: 'See our My Jersey® come to life and get to know all important info like bio and stats.',
        text: 'Data support will help fans understand how a team or player has performed over the course of a match or season. Stats, like the number of shots, shots on target, and ball possession, can offer a guide of how a player has performed and if his performance was in line with the result of the match.',
        icon: IconPlayerStats,
        video: PlayerStatsVideo,
    },
];

export default Experiences;
